import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const UsersIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 14.2651C12.93 14.2651 13.95 14.4001 15.06 14.6701C16.32 14.9851 17.34 15.4051 18.12 15.9301C19.05 16.5451 19.515 17.2351 19.515 18.0001V19.8901H4.48499V18.0001C4.48499 17.2351 4.94998 16.5451 5.87999 15.9301C6.65999 15.4051 7.67998 14.9851 8.93999 14.6701C10.05 14.4001 11.07 14.2651 12 14.2651ZM12 12.3751C11.325 12.3751 10.7025 12.2064 10.1325 11.8689C9.56248 11.5314 9.10874 11.0776 8.77123 10.5076C8.43373 9.9376 8.26499 9.31511 8.26499 8.64011C8.26499 7.9651 8.43373 7.33511 8.77123 6.75011C9.10874 6.1651 9.56248 5.70386 10.1325 5.36636C10.7025 5.02886 11.325 4.86011 12 4.86011C12.675 4.86011 13.2975 5.02886 13.8675 5.36636C14.4375 5.70386 14.8912 6.1651 15.2287 6.75011C15.5662 7.33511 15.735 7.9651 15.735 8.64011C15.735 9.31511 15.5662 9.9376 15.2287 10.5076C14.8912 11.0776 14.4375 11.5314 13.8675 11.8689C13.2975 12.2064 12.675 12.3751 12 12.3751Z'
        />
    ),
})

UsersIcon.displayName = 'UsersIcon'
